module.exports = __webpack_public_path__ + "static/bayer-logo-4c73e517996ec8a763db49888a366c5f.png";